import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Champ } from './constantes';

const VIDE = { prenom: '', nom: '', qualite: '', organisation: '', email: '' };

export const AjoutExterneDialog = ({ open, onClose, onAjouter }) => {
  const [f, setF] = useState(VIDE);
  useEffect(() => { if (open) setF(VIDE); }, [open]);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const valider = () => {
    if (!f.nom.trim()) return toast.error('Le nom est obligatoire');
    onAjouter({ ...f, nom: f.nom.trim(), role: '', user_id: null, presence: '' });
    return onClose();
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="cp-externe-dialog">
        <DialogHeader><DialogTitle>Personne extérieure</DialogTitle></DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          <Champ label="Prénom"><Input value={f.prenom} onChange={set('prenom')} data-testid="cp-externe-prenom" /></Champ>
          <Champ label="Nom *"><Input value={f.nom} onChange={set('nom')} data-testid="cp-externe-nom" /></Champ>
          <Champ label="Qualité"><Input value={f.qualite} onChange={set('qualite')} placeholder="Ex : représentant OPCO" data-testid="cp-externe-qualite" /></Champ>
          <Champ label="Organisation"><Input value={f.organisation} onChange={set('organisation')} placeholder="Ex : AFDAS" data-testid="cp-externe-organisation" /></Champ>
          <Champ label="E-mail" className="sm:col-span-2"><Input type="email" value={f.email} onChange={set('email')} data-testid="cp-externe-email" /></Champ>
        </div>
        <DialogFooter>
          <Button onClick={valider} className="bg-[#0F172A]" data-testid="cp-externe-ajouter">Ajouter</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
